import { HelpCircle } from 'lucide-react'

import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { USD_MOCK_TOKEN } from '@/domain/types/Token'
import { Tooltip, TooltipContentShort, TooltipTrigger } from '@/ui/atoms/tooltip/Tooltip'
import { Typography } from '@/ui/atoms/typography/Typography'
import { cn } from '@/ui/utils/style'
import Image from 'next/image'

export interface TileProps {
  title: string
  mobileTitle?: string
  USDValue: NormalizedUnitNumber
  icon?: string
  description?: string
  'data-testid'?: string
  className?: string
  textWrapperClassName?: string
}

export function Tile({
  icon,
  title,
  mobileTitle,
  USDValue,
  description,
  'data-testid': dataTestId,
  className,
  textWrapperClassName,
}: TileProps) {
  return (
    <div className={cn('flex items-center gap-2 md:gap-3', className)} data-testid={dataTestId}>
      {icon && (
        <div className="flex rounded-sm border bg-accent p-1.5 lg:p-4 md:p-3">
          <Image src={icon} alt={title} className="w-6 lg:w-8 md:w-7" />
        </div>
      )}
      <div className={cn('flex flex-col', textWrapperClassName)}>
        <div className="flex items-center gap-1">
          {mobileTitle ? (
            <>
              <Typography className="block sm:hidden" variant="prompt">
                {mobileTitle}
              </Typography>
              <Typography className="hidden sm:block" variant="prompt">
                {title}
              </Typography>
            </>
          ) : (
            <Typography variant="prompt">{title}</Typography>
          )}

          {description && (
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle size={16} className="text-icon-foreground/50" />
              </TooltipTrigger>
              <TooltipContentShort>{description}</TooltipContentShort>
            </Tooltip>
          )}
        </div>
        <div className="mt-2 flex gap-1 font-semibold text-base md:gap-2 lg:text-2xl md:text-xl">
          <div className="font-medium text-muted-foreground">$</div>
          <Typography variant="p" className="font-semibold text-xl sm:text-2xl" gradient>
            {USD_MOCK_TOKEN.format(USDValue, { style: 'compact' })}
          </Typography>
        </div>
      </div>
    </div>
  )
}
